/**
 * Keilog brand tokens (BC-*), from
 * ConceptDesigns/_templates/_brand-color-design-rule.md.
 *
 * The single source for both portal themes and, in custom-property form, for
 * `styles/_tokens.scss`. Keep the two in step.
 */
/** BC-* brand tokens. */
export const KEILOG_BRAND = {
  brand: '#0054AC',
  brandHover: '#1487FF',
  brandDeep: '#003267',
  brandDark: '#001F47',
  brandLight: '#E5EDF7',
  brandPale: '#F5FAFF',

  accent: '#EE66A2',
  accentBright: '#FF9AC4',
  accentDeep: '#C2185B',

  canvas: '#F9F8F6',
  surface: '#FFFFFF',
  border: '#DCDFE6',

  inkBody: '#212121',
  inkLabel: '#6E7280',

  /**
   * Public auth screens only (ログイン), the `--auth-*` values; they come from
   * KEiLOG's login design and sit outside the DS-01 ink ramp.
   */
  authLabel: '#3E515B',
  authHint: '#73818F',

  /**
   * DS-01 ink ramp, the `--ink-*` values of `styles/_tokens.scss`. Repeated here
   * because `ConfigProvider` builds its tokens from literal colours.
   */
  ink50: '#F9F8F6',
  ink100: '#F1F3F7',
  ink200: '#E4E7EE',
  ink300: '#C8CED8',
  ink400: '#9BA4B5',
  ink500: '#6E7990',
  ink600: '#4A5670',
  ink700: '#2C3851',
  ink800: '#1B2537',
  ink900: '#0B1220',

  /** Status palette, the `--success-*` / `--warn-*` / `--danger*` values. */
  successPale: '#E6F2EC',
  successDeep: '#2E7D5C',
  warnPale: '#FCF0E0',
  warnDeep: '#A85B04',
  dangerPale: '#FFF1F7',
  danger: '#E60044',
} as const;
